import {ActionReducerMap} from '@ngrx/store';
import {DialogsState} from './dialogs.state';
import {
  dialogWhereIsDatevClientIdReducers,
} from '../dialog-where-is-datev-client-id/+store/dialog-where-is-datev-client-id.reducers';
import {
  dialogDeleteConfigurationReducers
} from '../dialog-delete-configuration/+store/dialog-delete-configuration.reducers';


export const dialogsReducers: ActionReducerMap<DialogsState> = {
  dialogWhereIsDatevClientId: dialogWhereIsDatevClientIdReducers,
  dialogDeleteConfiguration: dialogDeleteConfigurationReducers,
};
